import React, { CSSProperties, FC } from "react";
// import parse from "html-react-parser";
import style from "./style.module.scss";
import appConfig from "../../util/appConfig";
import parseHtmlFromText from "../../util/parseHtmlFromText";

interface IFormWrapper {
  children: React.ReactNode;
  withHints?: boolean;
  hints?: string[];
  customFirsItemAtHints?: React.ReactNode;
  customStyle?: CSSProperties;
}

export const FormWrapper: FC<IFormWrapper> = ({
  children,
  customFirsItemAtHints,
  customStyle = {},
  hints = [],
  withHints = false,
}) => {
  const generateBackground = (env: string) => {
    switch (env) {
      case "awl": {
        return "rgba(239, 246, 255, 0.5)";
      }
      case "ebwo": {
        return "rgba(0, 70, 145, 0.05)";
      }
      case "lra": {
        return "rgba(39, 77, 56, 0.05)";
      }
      case "calw": {
        return "rgba(0, 70, 145, 0.05)";
      }
      default: {
        return "rgba(239, 246, 255, 0.5)";
      }
    }
  };
  return (
    <div
      className={`${style.formComponentWrapper} ${style.formComponentWrapperHelperWrapper}`}
      style={customStyle}
    >
      <div className={style.formWrapper}>{children}</div>
      {withHints ? (
        <aside
          className={style.hintWrapper}
          style={{
            backgroundColor: generateBackground(appConfig.logo),
          }}
        >
          {customFirsItemAtHints ? customFirsItemAtHints : null}
          <div className={style.hintTitle}>Hinweis</div>
          <ul className={style.list}>
            {hints.map((el, idx) => {
              return (
                <li key={idx}>
                  {parseHtmlFromText(el)}
                  {/* {parse(el)} */}
                </li>
              );
            })}
          </ul>
        </aside>
      ) : null}
    </div>
  );
};
